import { Type } from "class-transformer";
import { IsOptional } from "class-validator";
import { TemplateDetailsGeneralFieldDto } from "./template-details-general-field.dto";

export class TemplateDetailsGeneralDto {
  @IsOptional()
  @Type(() => TemplateDetailsGeneralFieldDto)
  showPrices?: TemplateDetailsGeneralFieldDto;
}
